const NOTIFICATION_MESSAGE = '@extensiv-app/notification'
const REQUEST_ORG_CHANGE = '@extensiv-app/requestOrgChange'

export default {
  NOTIFICATION_MESSAGE,
  REQUEST_ORG_CHANGE
}
